<template>
  <CHeader fixed with-subheader light>
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink>
      </CHeaderNavItem> -->
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/users" exact>Users</CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>Settings</CHeaderNavLink>
      </CHeaderNavItem>-->
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell" />
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list" />
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open" />
        </CHeaderNavLink>
      </CHeaderNavItem>-->
      <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3">
      <!-- <CBreadcrumb v-if="items.length" :items="items" class="border-0 mb-0" /> -->
      <!-- <CBreadcrumbRouter
        v-if="!items.length"
        ref="breadscrum"
        class="border-0 mb-0"
      /> -->
      <v-breadcrumbs :items="items" divider="/"></v-breadcrumbs>
    </CSubheader>
  </CHeader>
</template>

<script>
import { bus } from "@/main.js";
import config from "@/config.js";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { mapGetters } from "vuex";
import navInfo from "@/methods/navLinks.vue";
import getCurrentNav from "@/methods/utilities.vue";
export default {
  mixins: [navInfo, getCurrentNav],
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      items: [],
      updated_nav: [],
    };
  },
  created() {
    bus.$on("CHAT_BREADCRUMB_CHANGE", (data) => {
      this.items = data;
      // console.log(this.items)
    });
    bus.$on("SYSTEM_CHAT_MESSAGE", (data) => {
      if (this.$route.name == "chat") {
        bus.$emit("HANDLE_SYSTEM_CHAT_MESSAGE", data);
      } else {
        // this.is_chat_read = false;
        // this.$notifier.call(data.text, {});
      }
    });
  },
  beforeDestroy() {
    bus.$off("SYSTEM_CHAT_MESSAGE");
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      let url = `${config.BASE_URL}api/v2/admin/login/users/info`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.$store.commit("setNav", this.navInfo);
          let userDetails = response.body.data;
          this.$store.dispatch("setUserDetails", userDetails);
          this.getUpdatedNav(userDetails.permissions);
          this.getBreadcrumbsItems();
        }
      });
    },

    getUpdatedNav(permissions) {
      let updatedNav = this.nav.map((n) => {
        n._children = n._children
          .map((child) => {
            if (child.condition && !child.condition(permissions)) {
              return null;
            }
            if (!child.items) {
              return child;
            }
            child.items = child.items
              .map((item) => {
                if (item.condition && !item.condition(permissions)) {
                  return null;
                }
                return item;
              })
              .filter((i) => i);
            return child;
          })
          .filter((c) => c);
        return n;
      });
      this.updated_nav = updatedNav;
      localStorage.setItem("updatedNav", JSON.stringify(this.updated_nav));
      if (
        window.location.pathname === "/login" ||
        window.location.pathname === "/"
      ) {
        this.getCurrentNav(this.updated_nav);
      }
    },

    getBreadcrumbsItems() {

      this.items = [
        {
          text: "Home",
          disabled: !this.permissions.includes("VIEW_DASHBOARD"),
          to: "/dashboard",
        },
        {
          text: this.$route.name,
          disabled: true,
          to: this.$route.path,
        },
      ];
    },
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
      nav: "getNav",
    }),
  },
  watch: {
    "$route.name": function (routeName) {
      const params = Object.keys(this.$route.params)
    
      if (!params.includes('chatId') && !params.includes('user_name')) {
        this.getBreadcrumbsItems();
      }

    },
  },
};
</script>
